<template>
  <div class="brand-positioning-container">
    <div class="brand-positioning flex-between">
      <!-- 左侧标题区域 -->
      <div class="titles-section">
        <div class="brand-title">品牌定位</div>
        <div
          v-for="(item, index) in items"
          :key="index"
          class="title-item"
          :class="{ 'title-item-active': currentIndex === index }"
          @mouseenter="handleTitleHover(index)"
        >
          <div
            class="main-title flex-start"
            :class="{ 'main-title-active': currentIndex === index }"
          >
            <img :src="item.selectedIcon" v-if="currentIndex == index" />
            <img :src="item.orgIcon" v-else />
            {{ item.mainTitle }}
          </div>

          <div
            class="sub-title"
            :class="{ 'sub-title-show': currentIndex === index }"
          >
            {{ item.subTitle }}
          </div>
        </div>
      </div>

      <!-- 右侧图片轮播区域 -->
      <div class="images-section">
        <swiper
          ref="mySwiper"
          :options="swiperOptions"
          class="swiper-container"
          @slide-change="onSlideChange"
        >
          <swiper-slide v-for="(item, index) in items" :key="index">
            <div class="image-wrapper">
              <img :src="item.image" :alt="item.mainTitle" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "BrandPositioning",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      currentIndex: 0,
      items: [
        {
          orgIcon: require("@/assets/imgs/brand10.png"),
          selectedIcon: require("@/assets/imgs/brand01.png"),
          mainTitle: "核心资源优势",
          subTitle:
            "通过整合供应链资源，为终端门店提供涵盖管道水暖、电工电料、工具劳保、装饰建材等11大品类、超一百五十多万SKU的海量商品资源",
          image: "https://ztc-obs.zgztc.cn/2025/12/25/1ff917cd-97c7-4ca9-a317-766512e093d8.png",
        },
        {
          orgIcon: require("@/assets/imgs/brand03.png"),
          selectedIcon: require("@/assets/imgs/brand30.png"),
          mainTitle: "运营模式特点",
          subTitle:
            "平台通过数字化采购系统，实现一站式全品类下单，并协同全国各区域服务商构建本地化仓储与物流网络，确保高效、稳定的供货体验",
          image: "https://ztc-obs.zgztc.cn/2025/12/25/b43091e2-4171-4da0-b923-5550be34c517.png",
        },
        {
          orgIcon: require("@/assets/imgs/brand02.png"),
          selectedIcon: require("@/assets/imgs/brand20.png"),
          mainTitle: "会员服务体系",
          subTitle:
            "致力于为会员打造极具竞争力的价格体系与灵活的支付解决方案，同时会员还能享受专属客服、营销福利等增值服务，真正实现采购流程的数字化升级",
          image:"https://ztc-obs.zgztc.cn/2025/12/25/c60bfa18-809c-438e-8fb9-916d7c2a4304.png",
        },
      ],
      swiperOptions: {
        direction: "vertical",
        loop: false,
        speed: 600,
        effect: "slide",
        noSwiping: false,
        allowTouchMove: true,
        on: {
          slideChange: () => {
            this.onSlideChange();
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.$swiper : null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.swiper) {
        this.swiper.on("slideChange", () => {
          this.onSlideChange();
        });
      }
    });
  },
  methods: {
    handleTitleHover(index) {
      this.currentIndex = index;
      if (this.swiper) {
        this.swiper.slideTo(index, 600);
      }
    },
    onSlideChange() {
      if (this.swiper) {
        const activeIndex = this.swiper.activeIndex;
        if (activeIndex >= 0 && activeIndex < this.items.length) {
          this.currentIndex = activeIndex;
        } else if (activeIndex < 0) {
          this.currentIndex = 0;
        } else if (activeIndex >= this.items.length) {
          this.currentIndex = this.items.length - 1;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.brand-positioning-container {
  width: 1170px;
  height: 550px;
  background: linear-gradient(180deg, #f5f6fa 0%, #fbfbfd 100%);
  border-radius: 20px;
  margin: 50px auto 0 auto;

  .brand-positioning {
    max-width: 1170px;
    margin: 0 auto;
    padding: 25px 25px 25px 50px;
    display: flex;
    justify-content: space-between;

    .titles-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
      
      .brand-title {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 40px;
        color: #3e3e3e;
        margin-bottom: 40px;
        transition: all 0.3s ease;
      }

      .title-item {
        width: 500px;
        height: 100px;
        padding: 18px;
        margin-bottom: 10px;
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        position: relative;
        overflow: hidden;
        
        // 添加背景渐变动画
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(216deg, #ffffff 0%, rgba(255, 255, 255, 0.5) 100%);
          opacity: 0;
          border-radius: 20px;
          transition: opacity 0.4s ease;
          z-index: -1;
        }
        
        .main-title {
          font-family: MicrosoftYaHei;
          font-size: 20px;
          color: #3e3e3e;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          transition: all 0.3s ease;
          position: relative;
          z-index: 1;
          
          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
            transition: all 0.3s ease;
            transform-origin: center;
          }
        }

        .main-title-active {
          font-weight: bold;
          font-size: 22px;
          transform: translateX(5px); 
          
          img {
            transform: scale(1.2); 
            filter: brightness(1.2); 
          }
        }

        .sub-title {
          font-size: 16px;
          margin-top: 15px;
          color: #585f65;
          line-height: 24px;
          max-height: 0;
          opacity: 0;
          overflow: hidden;
          transition: all 0.5s ease;
          margin-left: 25px;
          transform: translateY(-10px);
        }

        .sub-title-show {
          max-height: 100px; 
          opacity: 1;
          transform: translateY(0);
          display: block;
        }
        
        // 悬停状态的基础样式
        &:hover:not(.title-item-active) {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
          
          &::before {
            opacity: 0.7;
          }
          
          .main-title {
            
            img {
              transform: scale(1.1);
            }
          }
        }
      }

      .title-item-active {
        width: 500px;
        height: 160px;
        background: linear-gradient(216deg, #ffffff 0%, rgba(255, 255, 255, 0.5) 100%);
        box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.1);
        border-radius: 20px;
        margin-bottom: 20px;
        transform: translateY(-5px) scale(1.02);
        animation: activeItem 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        
        .main-title {
          font-weight: bold;
          font-size: 22px;
          
          img {
            transform: scale(1.2);
            filter: brightness(1.2);
          }
        }
        
        .sub-title-show {
          animation: fadeInUp 0.5s ease 0.1s both;
        }
      }
    }
  }
}

/* 右侧图片区域样式 */
.images-section {
  width: 530px;
  height: 500px;
  position: relative;
  
  .swiper-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 15px;
    // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    // transition: box-shadow 0.3s ease;
    
    // &:hover {
    //   box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
    // }
    
    .image-wrapper {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      border-radius: 15px;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }
      
      &:hover img {
        transform: scale(1.05);
      }
    }
  }
}

// 动画定义
@keyframes activeItem {
  0% {
    transform: translateY(0) scale(1);
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05);
  }
  50% {
    transform: translateY(-8px) scale(1.03);
    box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.15);
  }
  100% {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.1);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1200px) {
  .brand-positioning-container {
    width: 95%;
    height: auto;
    min-height: 550px;
  }
}
</style>